var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"backButton",on:{"click":_vm.goBack}},[_c('li',[_c('AtomIcon',{attrs:{"color":"brand-primary","type":"arrow-left"}}),_c('AtomTextBody',[_vm._v(" Terug ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }